<template>
  <div class="staff">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <staff-avatar :size="40" :user="staffInfo"></staff-avatar>
        <span class="name">
          {{ staffInfo.name }}
        </span>
      </div>
      <div class="staff-info">
        <div class="item">
          <div class="label">姓名</div>
          <div class="info">{{ staffInfo.name }}</div>
        </div>
        <div class="item">
          <div class="label">手机号</div>
          <div class="info">{{ staffInfo.telephone }}</div>
        </div>
        <div class="item">
          <div class="label">部门</div>
          <div class="info">{{ staffInfo.departmentNameStr }}</div>
        </div>
        <div class="item">
          <div class="label">职位</div>
          <div class="info">{{ staffInfo.position }}</div>
        </div>
        <div class="item">
          <div class="label">汇报对象</div>
          <div class="info">{{ staffInfo.superior }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "staff",
  components: { StaffAvatar },
  props: {
    staffInfo: Object
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.staff {
  .el-card {
    border: none;
    box-shadow: none;
    .name {
      margin-left: 10px;
      position: absolute;
      margin-top: 12px;
      font-size: 14px;
    }
    .staff-info {
      display: flex;
      flex-flow: column;
      .item {
        display: flex;
        .label {
          color: #606266;
          font-size: 12px;
          line-height: 36px;
          float: left;
          width: 60px;
        }
        .info {
          font-size: 12px;
          line-height: 36px;
          position: relative;
        }
      }
    }
    ::v-deep .el-card__header {
      padding: 15px 20px 8px 20px;
    }
  }
  ::v-deep {
    .el-card__body {
      padding: 10px 20px 10px 20px;
    }
  }
}
</style>
